import { defineComponent as i, ref as m, computed as s, resolveComponent as g, openBlock as t, createElementBlock as c, normalizeClass as l, normalizeStyle as p, renderSlot as h, createBlock as y, createCommentVNode as k } from "vue";
import { hslToColorString as f, generateHslFromString as S } from "@onereach/ui-components-common/utils";
import { O as b } from "./OrIcon-k8cyvh-D.mjs";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var r = /* @__PURE__ */ ((e) => (e.XL = "xl", e.L = "l", e.M = "m", e.S = "s", e.XS = "xs", e))(r || {}), o = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Blue = "blue", e.Grey = "grey", e.Green = "green", e.Yellow = "yellow", e.Red = "red", e))(o || {});
const w = [
  // Layout
  "layout-inline-row justify-center",
  // Overflow
  "overflow-hidden",
  // Interactivity
  "interactivity-default",
  // Shape
  "rounded-full"
], v = {
  [r.XL]: [
    // Box
    "w-[80px]",
    "h-[80px]"
  ],
  [r.L]: [
    // Box
    "w-[64px]",
    "h-[64px]"
  ],
  [r.M]: [
    // Box
    "w-[40px]",
    "h-[40px]"
  ],
  [r.S]: [
    // Box
    "w-[32px]",
    "h-[32px]"
  ],
  [r.XS]: [
    // Box
    "w-[24px]",
    "h-[24px]"
  ]
}, L = {
  [r.XL]: [
    // Typography
    "text-[40px]"
  ],
  [r.L]: [
    // Typography
    "text-[32px]"
  ],
  [r.M]: [
    // Typography
    "text-[20px]"
  ],
  [r.S]: [
    // Typography
    "text-[16px]"
  ],
  [r.XS]: [
    // Typography
    "text-[16px]"
  ]
}, X = {
  [r.XL]: [
    // Typography
    "typography-headline-1"
  ],
  [r.L]: [
    // Typography
    "typography-headline-1"
  ],
  [r.M]: [
    // Typography
    "typography-body-1-bold"
  ],
  [r.S]: [
    // Typography
    "typography-body-1-bold"
  ],
  [r.XS]: [
    // Typography
    "typography-caption-semibold"
  ]
}, O = {
  [o.Auto]: [
    // Theme
    "theme-foreground-base",
    "dark:theme-foreground-base-dark"
  ],
  [o.Blue]: [
    // Theme
    "theme-foreground-on-primary",
    "dark:theme-foreground-on-primary-dark",
    "theme-background-primary",
    "dark:theme-background-primary-dark"
  ],
  [o.Grey]: [
    // Theme
    "theme-foreground-on-secondary",
    "dark:theme-foreground-on-secondary-dark",
    "theme-background-secondary",
    "dark:theme-background-secondary-dark"
  ],
  [o.Green]: [
    // Theme
    "theme-foreground-on-success",
    "dark:theme-foreground-on-success-dark",
    "theme-background-success",
    "dark:theme-background-success-dark"
  ],
  [o.Yellow]: [
    // Theme
    "theme-foreground-on-warning",
    "dark:theme-foreground-on-warning-dark",
    "theme-background-warning",
    "dark:theme-background-warning-dark"
  ],
  [o.Red]: [
    // Theme
    "theme-foreground-on-error",
    "dark:theme-foreground-on-error-dark",
    "theme-background-error",
    "dark:theme-background-error-dark"
  ]
}, z = i({
  name: "OrAvatar",
  components: {
    OrIcon: b
  },
  props: {
    src: {
      type: String,
      default: void 0
    },
    icon: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: () => r.M
    },
    color: {
      type: String,
      default: () => o.Auto
    },
    colorSalt: {
      type: String,
      default: void 0
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const n = m(), a = s(() => [
      "or-avatar-v3",
      ...w,
      ...v[e.size],
      ...e.icon ? L[e.size] : X[e.size],
      ...O[e.color]
    ]), d = s(() => ({
      background: e.color === o.Auto && !e.src ? f(S(e.colorSalt ?? "")) : void 0
    }));
    return {
      root: n,
      rootStyles: a,
      rootInlineStyles: d
    };
  }
}), I = ["src"];
function _(e, n, a, d, B, M) {
  const u = g("OrIcon");
  return t(), c("div", {
    ref: "root",
    class: l(e.rootStyles),
    style: p(e.rootInlineStyles)
  }, [
    h(e.$slots, "default", {}, () => [
      e.src ? (t(), c("img", {
        key: 0,
        class: l(["w-full", "h-full", "object-cover"]),
        src: e.src,
        alt: ""
      }, null, 8, I)) : e.icon ? (t(), y(u, {
        key: 1,
        icon: e.icon,
        size: "inherit"
      }, null, 8, ["icon"])) : k("", !0)
    ])
  ], 6);
}
const R = /* @__PURE__ */ x(z, [["render", _]]);
export {
  r as A,
  R as O,
  o as a
};
//# sourceMappingURL=OrAvatar-XcP_rrT3.mjs.map
